import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/event_sample1.png")